export const SET_LOADING_RALLY = 'SET_LOADING_RALLY';
export const ERROR_FETCHING_RALLY = 'ERROR_FETCHING_RALLY';
export const SET_RALLY_CODE = 'SET_RALLY_CODE';
export const RESET_RALLY = 'RESET_RALLY';
